import cn from "class-names"
import styles from "@components/Listings/ListingsFilter/ListingsFilter.module.scss"
import { StarsSelect } from "@components/Listings/ListingsFilter/components/StarsSelect"
import React from "react"
import { useFilterStore } from "@components/Listings/ListingsFilter/store"

export function StarsRating() {
    const value = useFilterStore((s) => s.stars_gte)
    const onStarsChange = useFilterStore((s) => s.onStarsChange)
    return (
        <div className={cn(styles.starContainer, styles.filterItem)}>
            <div className={styles.itemTitle}>Deal Score</div>
            <StarsSelect onChange={onStarsChange} value={value} />
        </div>
    )
}
